module.exports = __webpack_public_path__ + "img/Avivia.59d2df47.png";